export class MigrolClusterRenderer {

    constructor(markerImageUrl) {
        this.markerImageUrl = markerImageUrl;
    }

    render({ count, position }) {
        // create marker
        return new window.google.maps.Marker({
            position,
            icon: {
                url: this.markerImageUrl,
                scaledSize: new window.google.maps.Size(50, 25),
            },
            label: {
                text: String(count),
                color: '#fff',
                fontFamily: 'DIN W05 Bold,Arial,Helvetica,sans-serif',
                fontSize: '14px',
                fontWeight: 'normal'
            },

            // adjust zIndex to be above other markers
            zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
        });
    }
}